<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :width="filterInfo.width"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="primary" @click="goToApply"
          >我要申请产品质量评价</eui-btn
        >
        <eui-btn type="weak" @click="showAgreementListDialog()"
          >查看质量评价委托协议</eui-btn
        >
      </div>
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :indexShow="true"
        :loading="tableLoading"
      >
        <template v-slot:applyCode="slot">
          <div>
            <eui-btn
              font-size="12px"
              type="link"
              @click="handleBtn(slot.scope.row)"
              >{{ slot.scope.row.applyCode }}</eui-btn
            >
          </div>
        </template>
        <template v-slot:totalAmount="slot">
          <div>
            <span>{{ slot.scope.row.totalAmount | thousandsSeparator }}</span>
          </div>
        </template>
        <template v-slot:operation="slot">
          <eui-btn
            font-size="12px"
            type="link"
            @click="handleBtn(slot.scope.row)"
            v-if="checkShowBtn('查看', slot.scope.row.applyStatus)"
          >
            查看
          </eui-btn>
          <eui-btn
            fontSize="12"
            type="link"
            @click="handleBtn(slot.scope.row)"
            v-if="checkShowBtn('支付', slot.scope.row.applyStatus)"
          >
            支付
          </eui-btn>
          <eui-btn
            fontSize="12"
            type="link"
            @click="handleEditBtn(slot.scope.row)"
            v-if="checkShowBtn('修改', slot.scope.row.applyStatus)"
          >
            修改
          </eui-btn>
          <eui-btn
            fontSize="12"
            type="link"
            @click="handleUploadBtn(slot.scope.row)"
            v-if="checkShowBtn('上传资料', slot.scope.row.applyStatus)"
          >
            上传资料
          </eui-btn>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryParams.pageNum"
          :total="total"
          :page-size.sync="queryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <!-- 委托协议列表弹框 -->
    <agreementListDialog
      :agreementVisible="agreementVisible"
      @submitPopupData="agreementSubmitPopupData"
      @resetPopupData="agreementResetPopupData"
      :agreementList="agreementList"
    ></agreementListDialog>
    <!-- 跳转我的产品质量评价办法弹框 -->
    <eDialog
      dialogTitle="请选择供应商类型"
      :centerDialogVisible="producerVisible"
      @resetPopupData="setProducerResetPopupData"
      @submitPopupData="setProducerSubmitPopupData"
    >
      <div class="content-wrap">
        <el-radio v-model="supplierType" label="101">生产商</el-radio>
        <el-radio v-model="supplierType" label="103">流通商</el-radio>
      </div>
    </eDialog>
  </div>
</template>
<script>
import Api from '@/modules/projectA/api/evaluation';
import eTableList from '../../../components/common/e-table-list';
import eSearch from '../../../components/common/e-search';
import agreementListDialog from './component/agreementListDialog';
import applyStatus from './component/applysSatusList';
import eDialog from '@/components/common/e-dialog.vue';
export default {
  data() {
    function formatApplyStatus(status) {
      let str = '';
      switch (Number(status)) {
        case 217:
          str = '申请待确认';
          break;
        case 218:
          str = '已确认';
          break;
        case 219:
          str = '申请驳回';
          break;
        case 201:
          str = '待提交';
          break;
        case 205:
          str = '申请待确认';
          break;
        case 206:
          str = '资料初审';
          break;
        case 214:
          str = '资料复审';
          break;
        case 207:
          str = '审核驳回';
          break;
        case 208:
          str = '待支付';
          break;
        case 209:
          str = '支付中';
          break;
        case 210:
          str = '支付失败';
          break;
        case 211:
          str = '评价中';
          break;
        case 212:
          str = '评价完成';
          break;
        case 213:
          str = '订单关闭';
          break;
        case 216:
          str = '评价终止';
          break;
        default:
          break;
      }
      return str;
    }
    return {
      tableLoading: false,
      agreementVisible: false,
      agreementList: [],
      tableData: [],
      listQuery: {},
      total: 0,
      filterInfo: {
        data: {
          applyCode: null,
          applicant: null,
          applyStatus: null,
          applyTime: null,
          creditRound: null
        },
        fieldList: [
          {
            label: '申请单号',
            type: 'input',
            value: 'applyCode'
          },
          {
            label: '申请人',
            type: 'input',
            value: 'applicant'
          },
          {
            label: '申请状态',
            type: 'select',
            value: 'applyStatus',
            list: 'applyStatus'
          },
          {
            label: '申请日期',
            type: 'date',
            value: 'applyTime',
            dateType: 'daterange',
            valueFormat: 'yyyy-MM-dd'
          },
          {
            label: '评价类型',
            type: 'select',
            value: 'creditRound',
            list: 'rateType'
          }
        ],
        /**配置项 */
        btnStyle: [
          {
            icon: 'el-icon-search',
            text: '过滤',
            type: 'primary'
          },
          {
            icon: 'el-icon-refresh',
            text: '重置'
          }
        ],
        width: {
          labelWidth: 80,
          itemWidth: 220
        }
      },
      listTypeInfo: {
        applyStatus: applyStatus,
        rateType: [
          { id: null, name: '全部' },
          {
            id: 1,
            name: '初评'
          },
          {
            id: 0,
            name: '复评'
          }
        ]
      },
      tableLabel: [
        { label: '申请单号', slot: 'applyCode', align: 'center' },
        {
          label: '申请日期',
          param: 'applyTime',
          align: 'center',
          render(item) {
            let str = item.applyTime.substr(0, 10);
            return str;
          }
        },
        { label: '申请人', param: 'applicant', align: 'center' },
        { label: '评价费(元)', slot: 'totalAmount', align: 'center' },
        {
          label: '评价类型',
          param: 'creditRoundDesc',
          align: 'center'
          // render(item) {
          //   let str = '';
          //   if (item.creditRound === '1') {
          //     str = '初评';
          //   } else {
          //     str = '复评';
          //   }
          //   return str;
          // }
        },
        {
          label: '状态',
          param: 'applyStatus',
          align: 'center',
          render(item) {
            let str = formatApplyStatus(item.applyStatus);
            console.log(str);
            return str;
          }
        },
        { label: '操作', slot: 'operation', align: 'center' }
      ],
      queryParams: {
        applyCode: null,
        applicant: null,
        applyStatus: null,
        creditRound: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      },
      companyId: null,
      supplierType: null,
      producerVisible: false
    };
  },
  created() {
    this.getEvaluationApplyList(this.queryParams);
  },
  components: { eTableList, eSearch, agreementListDialog, eDialog },

  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    }
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler: function(newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
        }
      }
    }
  },
  methods: {
    handleFilter(options) {
      console.log(options);
      let {
        applyCode,
        applicant,
        applyStatus,
        applyTime,
        creditRound
      } = options;
      this.queryParams = {
        applyCode: applyCode,
        applicant: applicant,
        applyStatus: applyStatus,
        creditRound: creditRound,
        startTime: applyTime !== null ? applyTime[0] : null,
        endTime: applyTime !== null ? applyTime[1] : null,
        pageNum: 1,
        pageSize: 10
      };
      this.getEvaluationApplyList(this.queryParams);
    },
    agreementSubmitPopupData() {
      this.agreementVisible = false;
    },
    agreementResetPopupData() {
      this.agreementVisible = false;
    },
    //
    async showAgreementListDialog() {
      await this.getAgreementPdfList(res => {
        console.log(res);
        if (res.code === '200') {
          this.agreementList = res.data;
          this.agreementVisible = true;
        }
      });
    },
    //获取质量评价委托协议列表
    async getAgreementPdfList(callback) {
      let res = await Api.queryCommissionAttachmentList();
      callback(res);
    },
    getPurchaseDemandStatus(status) {
      console.log(status, 'valval');
      const { purchaseDemandStatusList } = this.listTypeInfo;
      const { name } =
        purchaseDemandStatusList.find(item => {
          return item.id === status;
        }) || {};
      return name;
    },
    // 审批提交
    async submitApprove(val) {
      try {
        const params = {
          contents: val,
          purchaseDemandId: this.paramsRow.purchaseDemandId,
          workflowDefinitionId: ''
        };
        if (this.workflowDefinitionId) {
          params.workflowDefinitionId = this.workflowDefinitionId;
        }

        const res = await Api.commitPurchaseDemand(params);
        if (res.code === '200') {
          // this.$message.success("提交审核成功");
          this.handleQuery();
          this.closeDia('auditInfoVisible');
        }
      } catch (err) {
        console.log(err);
      }
    },
    //获取审批信息
    async getApprovalList() {
      try {
        const params = {
          auditType: 3
        };
        let res = await Api.approveList(params);
        this.approvalList = res.data;
        // this.approvalList = [];
        if (this.approvalList.length !== 0) {
          // 有审批流
          this.showAuditMask = true;
        } else {
          // 无审批流
          this.auditInfoVisible = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getApprovalChain(val) {
      this.workflowDefinitionId = val;
      this.auditInfoVisible = true;
    },
    openApproval(row) {
      this.paramsRow = row;
      this.getApprovalList();
    },

    // 打开审核记录弹窗
    openAuditRecordDia(row) {
      this.auditRecordVisible = true;
      this.auditRecordRow = { ...row };
    },

    // 删除操作
    async handleDel() {
      const params = { purchaseDemandId: this.paramsRow.purchaseDemandId };
      const res = await Api.deletePurchaseDemand(params);
      if (res.code === '200') {
        this.closeDia('delVisible');
        this.listQuery = { ...this.cloneListQuery };
        this.getList(this.listQuery);
      }
    },

    handleBtn(row) {
      this.$router.push({
        path: '/ES/ESapply/productEvaluationInfo',
        query: {
          from: 'myApplyPage',
          applyStatus: row.applyStatus,
          applyId: row.applyId
        }
      });
    },
    goToDetail(row) {
      this.$router.push({
        path: '/ES/ESapply/productEvaluationInfo',
        query: {
          from: 'myApplyPage',
          applyStatus: row.applyStatus,
          applyId: row.applyId
        }
      });
    },
    handleEditBtn(row) {
      const { applyId = '', applyStatus = '' } = row;
      this.$router.push({
        path: `/ES/ESapply/editProductEvaluation`,
        query: applyId ? { applyId, applyStatus, from: 'myApplyPage' } : {}
      });
    },
    handleUploadBtn(row) {
      this.$router.push({
        path: '/ES/ESapply/uploadProductEvaluation',
        query: {
          from: 'myApplyPage',
          applyStatus: row.applyStatus,
          applyId: row.applyId
        }
      });
    },
    // 是否展示按钮
    checkShowBtn(type, status) {
      let flag = false;
      let tempFlag =
        status === '217' ||
        status === '218' ||
        status === '208' ||
        status === '209' ||
        status === '206' ||
        status === '205' ||
        status === '210' ||
        status === '214' ||
        status === '211' ||
        status === '212' ||
        status === '213' ||
        status === '216';
      if (type === '查看' && tempFlag) {
        flag = true;
      }
      if (
        type === '修改' &&
        (status === '219' || status === '206' || status === '207')
      ) {
        flag = true;
      }
      if (type === '支付' && (status === '208' || status === '210')) {
        flag = true;
      }
      if (type === '上传资料' && status === '218') {
        flag = true;
      }
      return flag;
    },

    // 获取列表数据
    async getEvaluationApplyList(params) {
      this.tableLoading = true;
      await Api.queryEvaluationApplyPageList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = res.data;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },

    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.queryParams = {
        applyCode: null,
        applicant: null,
        applyStatus: null,
        creditRound: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      };
      this.getEvaluationApplyList(this.queryParams);
    },

    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.createTime?.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        val.startTime = '';
        val.endTime = '';
        val.createTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },

    // 修改/新增
    goToApply() {
      // const { purchaseDemandId = '', purchaseDemandStatus = '' } = row;
      // this.$router.push({
      //   path: `/ES/ESapply/editProductEvaluation`,
      //   query: purchaseDemandId
      //     ? { purchaseDemandId, purchaseDemandStatus }
      //     : {},
      // });
      this.producerVisible = true;
    },

    goDetail(purchaseDemandId) {
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId }
      });
    },

    // 打开弹窗
    openDia(type, row) {
      this[type] = true;
      this.paramsRow = { ...row };
    },

    // 关闭弹窗
    closeDia(type) {
      this[type] = false;
      this.paramsRow = {};
    },
    setProducerResetPopupData() {
      this.producerVisible = false;
    },
    setProducerSubmitPopupData() {
      if (!this.supplierType) {
        this.$message.warning('这是提示');
        return false;
      }
      this.$router.push({
        path: '/applicationEvaluation',
        query: { supplierType: this.supplierType }
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.prompt-modal-title {
  display: flex;
  height: 40px;
  padding-left: 20px;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: $c3;
    line-height: 14px;
  }
}

.prompt-modal-content {
  > h4 {
    font-weight: 500;
    color: $c3;
    margin-bottom: 5px;
  }
}
.content-wrap {
  text-align: center;
}
</style>
